import React from 'react';
import { CheckCircleIcon, UserIcon } from 'lucide-react';
interface TestimonialCardRlt1Props {
  name: string;
  location: string;
  duration: string;
  testimonial: string;
}
const TestimonialCardRlt1 = ({
  name,
  location,
  duration,
  testimonial
}: TestimonialCardRlt1Props) => {
  return <div className="border-l-2 border-gray-800 pl-5 py-4 my-6 bg-gray-50 rounded-r shadow-sm" data-id="element-6756">
      <blockquote className="font-serif text-gray-700 italic mb-4 leading-relaxed text-base" data-id="element-6757">
        "{testimonial}"
      </blockquote>
      <div className="flex items-center border-t border-gray-200 pt-3" data-id="element-6758">
        <div className="w-6 h-6 rounded-full bg-gray-300 flex items-center justify-center mr-2" data-id="element-6759">
          <UserIcon className="h-3 w-3 text-gray-600" data-id="element-6760" />
        </div>
        <div className="text-sm text-gray-600" data-id="element-6761">
          <span className="font-medium text-gray-800" data-id="element-6762">{name}</span>
          <span className="mx-1" data-id="element-6763">•</span>
          <span data-id="element-6764">{location}</span>
          <span className="mx-1" data-id="element-6765">•</span>
          <span data-id="element-6766">Using product for {duration}</span>
        </div>
        <div className="ml-2 flex items-center text-green-600 text-xs font-medium border border-green-200 rounded-full px-2 py-0.5 bg-green-50" data-id="element-6767">
          <CheckCircleIcon className="h-3 w-3 mr-1" data-id="element-6768" />
          <span data-id="element-6769">Verified</span>
        </div>
      </div>
    </div>;
};
export default TestimonialCardRlt1;